import script from "./ReadyCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadyCheck.vue?vue&type=script&setup=true&lang=js"

import "./ReadyCheck.vue?vue&type=style&index=0&id=5e0cbe3c&lang=css"

const __exports__ = script;

export default __exports__